export default window.BACKEND_VALUES
